<div class="p-3 toasters" *ngIf="toasters.length">
  <div class="mobile-toaster {{ item.severity }} {{ item.appear ? 'appear' : 'disappear' }}"  *ngFor="let item of toasters">
    <div class="text">
      <strong class="d-flex align-items-center gap-3">
        <i class="pi" [ngClass]="{
          'pi-times-circle' : item.severity == 'error',
          'pi-check-circle' : item.severity == 'success',
          'pi-exclamation-circle' : item.severity == 'warning',
          'pi-info-circle' : item.severity == 'info',
        }"></i> 
        {{ item.detail }}
      </strong>
    </div>
    <div class="bar {{ item.bar ? 'progress-bar-run' : 'progress-bar-stop' }}"></div>
  </div>
</div>